// Image modal component for displaying larger image previews
import React, { useEffect } from "react";
import { X, Download } from "lucide-react";
import { downloadImage, getImageFileName } from "../../../utils/imageUtils";

const ImageModal = ({ isOpen, onClose, imageSrc, imageAlt, messageId }) => {
  // Handle escape key to close modal
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      // Prevent body scroll when modal is open
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, onClose]);

  // Handle download button click
  const handleDownload = async (e) => {
    e.stopPropagation();
    const fileName = getImageFileName(imageSrc, messageId);
    const success = await downloadImage(imageSrc, fileName);

    if (!success) {
      // Show error toast or notification if needed
    }
  };

  // Don't render if not open
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="relative max-w-[90vw] max-h-[90vh] bg-bg-60 rounded-lg overflow-hidden shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header with close and download buttons */}
        <div className="absolute top-0 left-0 right-0 bg-gradient-to-b from-black/50 to-transparent p-4 z-10">
          <div className="flex justify-between items-center">
            <div className="flex gap-2">
              {/* Download button */}
              <button
                onClick={handleDownload}
                className="p-2 bg-black/30 hover:bg-black/50 rounded-full transition-colors text-white"
                title="Download image"
              >
                <Download size={20} />
              </button>
            </div>

            {/* Close button */}
            <button
              onClick={onClose}
              className="p-2 bg-black/30 hover:bg-black/50 rounded-full transition-colors text-white"
              title="Close"
            >
              <X size={20} />
            </button>
          </div>
        </div>

        {/* Image container */}
        <div className="flex items-center justify-center">
          <img
            src={imageSrc}
            alt={imageAlt || "Image preview"}
            className="max-w-full max-h-[90vh] object-contain"
            style={{ maxWidth: "90vw", maxHeight: "90vh" }}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
